
const MAX_DIMENSION = 2560;
const MIN_BYTES_TO_COMPRESS = 400 * 1024;
const QUALITY = 0.82;

const SKIP_TYPES = new Set(['image/gif', 'image/svg+xml']);

function canvasToBlob(canvas: HTMLCanvasElement, type: string, quality: number): Promise<Blob | null> {
  return new Promise((resolve) => canvas.toBlob(resolve, type, quality));
}

export async function compressImageFile(file: File): Promise<File> {
  if (!file.type.startsWith('image/') || SKIP_TYPES.has(file.type)) return file;
  if (file.size < MIN_BYTES_TO_COMPRESS) return file;
  try {
    const bitmap = await createImageBitmap(file);
    const scale = Math.min(1, MAX_DIMENSION / Math.max(bitmap.width, bitmap.height));
    const width = Math.round(bitmap.width * scale);
    const height = Math.round(bitmap.height * scale);
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    if (!ctx) return file;
    ctx.drawImage(bitmap, 0, 0, width, height);
    bitmap.close();
    const outType = file.type === 'image/png' ? 'image/webp' : 'image/jpeg';
    const blob = await canvasToBlob(canvas, outType, QUALITY);
    if (!blob || blob.size >= file.size * 0.9) return file;
    const ext = outType === 'image/webp' ? '.webp' : '.jpg';
    const name = file.name.replace(/\.[^.]+$/, '') + ext;
    return new File([blob], name, { type: outType, lastModified: file.lastModified });
  } catch {
    return file;
  }
}
